<template>
  <div v-if="readyToRender">
    <SimpleDemand v-if="this.current_demand.status == 'pending'"
                  :demand="this.current_demand">
    </SimpleDemand>

    <div v-else>
      <div class="alert alert-info m-t-30 m-b-30">
          <i class="fa fa-info-circle"></i> Cette demande a déjà été traitée
      </div>

      <router-link v-if="this.current_demand.customer_id" :to="{ name: 'customer', params: { id: this.current_demand.customer_id } }">
          <button class="btn btn-complete">Revenir à la fiche client</button>
      </router-link>
    </div>
  </div>
</template>
<script>

  import { mapActions, mapGetters, mapState } from 'vuex'
  import SimpleDemand from 'views/Demands/SimpleDemand'

  export default {

    components: {
      SimpleDemand
    },

    methods: {
      ...mapActions('demands', ['getValidationRequestById', 'validationRequestTreatmentForm', 'flush']),

      init () {
        this.flush()
          .then(() =>
            this.getValidationRequestById(this.$route.params.id)
          )
      },

    },

    computed: {
      ...mapState('demands', ['current_demands']),

      current_demand () {
        return (_.find(this.current_demands, (demand) => demand.id == this.$route.params.id))
      },

      readyToRender () {
        return !!this.current_demand
      },

    },

    mounted () {
      this.init()
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// client/views/Demands/LoneDemand.vue